import { RootState, selectLoggedInStatus } from '../store';
import { connect } from 'react-redux';
import Login, { PropsFromState, PropsFromDispatch } from '../components/Login';
import { Dispatch } from 'redux';
import { initiateLogin, updateLoginURL } from '../store/app/actions';

export const mapStateToProps = (
    state: RootState
): PropsFromState => ({
    loginURL: state.app.loginURL,
    isLoggedIn: selectLoggedInStatus(state)
});

export const mapDispatchToProps = (
    dispatch: Dispatch
): PropsFromDispatch => ({
    updateLoginURL: (url: string) => dispatch(updateLoginURL(url)),
    initiateLogin: (url: string) => dispatch(initiateLogin(url))
});

export default connect(mapStateToProps, mapDispatchToProps)
(Login);
